import { useMemo } from 'react'
import { useAuth } from '../../../auth'
import { podeEscreverFeriado, podeLerFeriado } from './escalaHelpers'

export type PermissoesFeriado = {
  /** `Feriado:read` — sem isto a aba nem aparece. */
  podeLer: boolean
  /** `Feriado:create|update|delete` — sem isto só a listagem é oferecida. */
  podeEscrever: boolean
}

/**
 * Resolve as permissões de feriado do usuário logado pelo **grupo**, o mesmo
 * eixo que o backend usa no `permission.json` e que o `PrivateRoutes` já lê em
 * `currentUser.grupo.nome`. Um único ponto para as três telas que precisam
 * disso (aba, botão "Novo feriado" e ações da linha), para não nascerem três
 * critérios divergentes.
 */
export const usePermissoesFeriado = (): PermissoesFeriado => {
  const { currentUser } = useAuth()
  const grupo = currentUser?.grupo?.nome

  return useMemo(
    () => ({ podeLer: podeLerFeriado(grupo), podeEscrever: podeEscreverFeriado(grupo) }),
    [grupo]
  )
}
